import React,{useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';

const Category_sell_table = () => {
    const { initState } = useContext(GlobalContext);
    return (
        <div className="mt-6">
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">فرۆشی کاتیگۆری</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کاتیگۆری
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                کۆی فرۆش
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                کۆی قازانج
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState?.category_sell_report.map((lis)=>(
                        <tr key={lis?.category_id} className="hover:bg-slate-50 transition-colors duration-100">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis?.category_name}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis?.total_sold))} $
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis?.total_summary_sold))} $
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Category_sell_table